import React from "react"
import { useTranslation } from "react-i18next";
import DialogTemplatePure from "../dialog-template/dialog-template.pure";

/**
 *
 * @typedef {Object} Props
 * @prop {Function} Props.cancel Function to the cancel button
 * @prop {Function} Props.submit Function to the submit button
 * @prop {ConfirmationData} Props.confirmationData Data from the response that confirm the variables going to be modified
 * @prop {React.CSSProperties} Props.customStylesCancelButton Styles for the cancel button
 */

/**
 *
 * @typedef {Object} ConfirmationData
 * @prop {string[]} ConfirmationData.variablesAdded Variables added to the questionnaaire
 * @prop {string[]} ConfirmationData.variablesDeleted Variables to be deleted
 * @prop {string[]} ConfirmationData.questionnaires questionnaires linked to the template
 */

/**
 * @param {Props} props
 * @returns {JSX}
 */
export default function ConfirmationDataModal({ cancel, submit, confirmationData, customStylesCancelButton }) {
    const { t } = useTranslation()

    return <DialogTemplatePure
        title={t("configurationPanelView.confirmUpdate")}
        saveBtn={"Aceptar"}
        handleSubmitProfile={submit}
        canelBtn={"Cancelar"}
        cancel={cancel}
        buttonCustomStyles={customStylesCancelButton}
    >
        <div className="digitalContractTemplatesDetails-dialog">
            <p className="digitalContractTemplatesDetails-dialog-title">Existen cuestionarios que utilizan este template. ¿Estás de acuerdo en actualizarlo?</p>
            {confirmationData.variablesAdded.length > 0 &&
                <>
                    <p>Se agregará(n) {confirmationData.variablesAdded.length} variable(s).</p>
                </>
            }
            {confirmationData.variablesDeleted.length > 0 &&
                <>
                    <p>Se eliminará(n) {confirmationData.variablesDeleted.length} variable(s) junto con las preguntas asociadas a esta(s).</p>
                </>
            }
            {confirmationData.questionnaires.length > 0 &&
                <>
                    <p>Los siguientes cuestionarios se verán afectados por los cambios:</p>
                    <ul>
                        {confirmationData.questionnaires.map((q, i) => <li key={i}>{q}</li>)}
                    </ul>
                </>
            }
        </div>
    </DialogTemplatePure>
}